export const boldText = "kGc";
export const italicText = "lGc";
export const underlineText = "mGc";
export const bulletsText = "nGc";
export const numberingText = "oGc";
export const outdentText = "pGc";
export const indentText = "qGc";
export const blockQuoteText = "rGc";
export const alignText = "sGc";
export const alignLeftText = "tGc";
export const alignRightText = "uGc";
export const alignCenterText = "vGc";
export const superscriptText = "wGc";
export const subscriptText = "xGc";
export const strikethroughText = "yGc";
export const dirLtrText = "zGc";
export const dirRtlText = "AGc";
export const removeFormatText = "BGc";
export const undoText = "CGc";
export const redoText = "DGc";
export const formatPainterText = "EGc";
export const changeCaseText = "FGc";
export const uppercaseText = "GGc";
export const lowercaseText = "HGc";
export const capitalizeEachWordText = "IGc";
export const sentenceCaseText = "JGc";
export const fontColorText = "KGc";
export const moreColorsText = "LGc";
export const customColorsText = "MGc";
export const noColorText = "NGc";
export const highlightColorText = "OGc";
export const cutText = "PGc";
export const copyControlText = "QGc";
export const pasteText = "RGc";
export const fontNameText = "SGc";
export const fontSizeText = "TGc";
export default {boldText,italicText,underlineText,bulletsText,numberingText,outdentText,indentText,blockQuoteText,alignText,alignLeftText,alignRightText,alignCenterText,superscriptText,subscriptText,strikethroughText,dirLtrText,dirRtlText,removeFormatText,undoText,redoText,formatPainterText,changeCaseText,uppercaseText,lowercaseText,capitalizeEachWordText,sentenceCaseText,fontColorText,moreColorsText,customColorsText,noColorText,highlightColorText,cutText,copyControlText,pasteText,fontNameText,fontSizeText};